import React from 'react';
import PropTypes from 'prop-types';
import {Box} from '@material-ui/core';
import useStyles from './GenericInputStyles';

const GenericInput = ({children, infiniteOptions, borderRadius, borderWidth, disabled, error}) => {

    const classes = useStyles({...infiniteOptions, borderRadius, borderWidth, disabled, error});

    return (
        <Box className={classes.root} disabled={disabled}>
            {children}
        </Box>
    );
};

GenericInput.propTypes = {
    children: PropTypes.any,
    infiniteOptions: PropTypes.shape({
        infiniteTop: PropTypes.bool,
        infiniteRight: PropTypes.bool,
        infiniteBottom: PropTypes.bool,
        infiniteLeft: PropTypes.bool,
    }),
    borderRadius: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    borderWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    disabled: PropTypes.bool,
    error: PropTypes.bool,
};

GenericInput.defaultProps = {
    children: null,
    infiniteOptions: {},
    borderRadius: null,
    borderWidth: null,
    disabled: false,
    error: false,
};

export default GenericInput;